const configs = {
  test: {
    env: "test",
    baseUrl: "https://backend-stg.apna.co",
    infra_base_url: "https://api.staging.infra.apna.co",
    communityBaseUrl: "https://api.staging.infra.apna.co",
    legacyBaseUrl: "https://backend-stg.apna.co",
    telecallingAssesmentQuestionId: "8577",
    gumletBaseUrl: "https://cdn.apna.co",
    enabledResumeParserUserIdRange: {
      min: 0,
      max: 100
    },
    deliveryAssesmentQuestionIds: {
      drivingLicense: "-55",
      bike: "-2",
      rc: "-13010"
    },
    questionIds: {
      city: "63635829aff432425334e33b",
      employmentType: "62bc658889d956268e3dc69e",
      workplace: "62bc660389d956268e3dc69f",
      shift: "62bc664e89d956268e3dc6a1",
      salary: "62bc794fb603a40d069dfbd8",
    },
    appVersionFeatureChecks: {
      multiPreferredCity: 862,
      preferredRoles: 902,
      NBlocation: 931,
      LanguageScreenRevamp: 960
    }
  },
  production: {
    env: "production",
    baseUrl: "https://production.apna.co",
    legacyBaseUrl: "https://production.apna.co",
    infra_base_url: "https://api.production.infra.apna.co",
    communityBaseUrl: "https://api.production.infra.apna.co",
    gumletBaseUrl: "https://cdn.apna.co",
    telecallingAssesmentQuestionId: "111182",
    enabledResumeParserUserIdRange: {
      min: 60,
      max: 69
    },
    deliveryAssesmentQuestionIds: {
      drivingLicense: "-55",
      bike: "-2",
      rc: "-7092"
    },
    questionIds: {
      city: "637fa64a6a66a62e5cc84406",
      employmentType: "62c5ae014c055b7adffb621b",
      workplace: "62c5ae233ebe4264d44f7efe",
      shift: "62c5ae50985c705beb685fb1",
      salary: "62c5aeb84c055b7adffb62bb",
    },
    appVersionFeatureChecks: {
      multiPreferredCity: 864,
      preferredRoles: 908,
      NBlocation: 931,
      LanguageScreenRevamp: 960
    }
  },
}

const env = import.meta.env.VITE_ENV as keyof typeof configs || "test";
export const config = {
    ...configs[env],
} as const;
